const faq = () => {
    const faqItems = document.querySelectorAll('.faq__wrapper-item');

    faqItems.forEach(el => {
        const button = el.querySelector('.arrow');
        const text = el.querySelector('.faq__wrapper-item__info');

        el.addEventListener('click', () => {
            button.classList.toggle('active');
            text.classList.toggle('active');
        });
    });

    const frequentButton = document.getElementById('faq-button__frequent');
    const todayButton = document.getElementById('faq-button__today');

    const frequentItems = document.getElementById('faq-items__frequent');
    const todayItems = document.getElementById('faq-items__today');

    if (frequentButton && todayButton && frequentItems && todayItems) {
        frequentButton.addEventListener('click', function() {
            if (!frequentButton.classList.contains('address-page_faq-button__active')) {
                frequentButton.classList.add('address-page_faq-button__active');
                todayButton.classList.remove('address-page_faq-button__active');

                frequentItems.style.display = 'block';
                todayItems.style.display = 'none';
            }
        });

        todayButton.addEventListener('click', function() {
            if (!todayButton.classList.contains('address-page_faq-button__active')) {
                todayButton.classList.add('address-page_faq-button__active');
                frequentButton.classList.remove('address-page_faq-button__active');

                todayItems.style.display = 'block';
                frequentItems.style.display = 'none';
            }
        });
    }
};

document.addEventListener('DOMContentLoaded', faq);
